
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/find-syllabus",
      function () {
        return require("private-next-pages/find-syllabus.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/find-syllabus"])
      });
    }
  